import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getUpcomingTasks(payload) {
  return { type: actionTypes.GET_UPCOMING_TASKS, payload };
}
export function getUpcomingTasksSuccess(payload) {
  return { type: actionTypes.GET_UPCOMING_TASKS_SUCCESS, payload: payload };
}
